import { render, staticRenderFns } from "./OrderNotesDetails.vue?vue&type=template&id=b3f85588&scoped=true"
import script from "./OrderNotesDetails.vue?vue&type=script&lang=ts"
export * from "./OrderNotesDetails.vue?vue&type=script&lang=ts"
import style0 from "./OrderNotesDetails.vue?vue&type=style&index=0&id=b3f85588&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b3f85588",
  null
  
)

export default component.exports